import template from './fatca-selector.html';

export default angular.module('app.holding.dashboard.onboarding')
  .directive('gmwFatcaSelector', gmwFatcaSelector)
  .name;

function gmwFatcaSelector() {
  'ngInject';

  const directive = {
    link,
    replace: true,
    require: ['ngModel', '^^?form'],
    restrict: 'E',
    scope: {
      nationalities: '=',
      usLabel: '@',
      ukLabel: '@',
    },
    template,
    transclude: true,
  };
  return directive;

  function link(scope, _element, _attrs, ctrls) {
    const ngModel = ctrls[0];
    scope.ngModel = ngModel;
    scope.form = ctrls[1];
    scope.model = {};

    ngModel.$setViewValue([]);
    scope.$watchGroup((['model.USA', 'model.UK']), ([usa, uk]) => {
      const value = [];
      if (usa) {
        value.push('US');
      }
      if (uk) {
        value.push('GB');
      }
      ngModel.$setViewValue(value);
    });
    scope.hasNationality = nationality => scope.nationalities.some(_ => _ === nationality);
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/onboarding/directives/fatca-selector/fatca-selector.js